import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

// plugins
import './plugins/element-ui'
import './plugins/lodash'
import './plugins/global-components'
import './plugins/filters'
import './plugins/v-clipboard'
import './plugins/editor'

// poly fill and global style
import '@babel/polyfill'
import 'mutationobserver-shim'
import 'normalize.css/normalize.css'
import '@/styles/index.scss'

// icons
import '@/icons'

// permission controller
import '@/permission'

Vue.prototype.customAction = { close: window.close }
Vue.prototype.env = process.env
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})
